function Eye(eye) {
    this.eye = eye;
    this.inner = this.eye.querySelector('.jsEyeInner');
    this.iris = this.eye.querySelector('.iris');
    this.pupil = this.eye.querySelector('.pupil');

    this.maxPosCount = 6;
    this.prevPos = 1;
    this.currentPos = 1;

    this.maxXOffset = 15;
    this.maxYOffset = 5;
    
    this.irisCenterX = 0;
    this.irisCenterY = 0;

    this.setIrisBounds();
    window.addEventListener('resize', _ => this.setIrisBounds());

    window.addEventListener('mousemove', e => {
        if (window.innerWidth >= 850) {
            const xOffset = (e.pageX - this.irisCenterX) * (this.maxXOffset / window.innerWidth);
            const yOffset = (e.pageY - this.irisCenterY) * (this.maxYOffset / window.innerHeight);

            gsap.to(this.iris, 0.5, { x: xOffset, y: yOffset, ease: 'power2.out' });
            gsap.to(this.pupil, 0.5, { x: xOffset * 1.8, y: yOffset * 2, ease: 'power2.out' });
        }
    });

    // Move the eye to random locations
    setTimeout(_ => this.startRandomLocationChange(), this.getRandomPositionChangeInterval());
}

Eye.prototype.setIrisBounds = function() {
    const bounds = this.iris.getBoundingClientRect();

    this.irisCenterX = bounds.x + (bounds.width / 2);
    this.irisCenterY = bounds.y + window.scrollY + (bounds.height / 2);
};

Eye.prototype.getNextPositionClass = function() {
    this.prevPos = this.currentPos;

    this.currentPos++;
    if (this.currentPos > this.maxPosCount) this.currentPos = 1;

    return 'pos' + this.currentPos;
};

Eye.prototype.startRandomLocationChange = function() {
    const newPosClass = this.getNextPositionClass();

    gsap.timeline()
        .to(this.eye, 1, { y: 10, opacity: 0, ease: 'power2.inOut' })

        .add(_ => {
            this.eye.classList.remove('pos' + this.prevPos);
            this.eye.classList.add(newPosClass);
        })

        .set(this.inner, { y: window.scrollY })
        .add(_ => this.setIrisBounds())
        .to(this.eye, 1, { y: 0, opacity: 1, ease: 'power2.inOut' })
        .to(this.eye, 1, { y: 10, opacity: 0, ease: 'power2.inOut' }, '+=5')
    ;

    setTimeout(_ => this.startRandomLocationChange(), this.getRandomPositionChangeInterval());
};

Eye.prototype.getRandomPositionChangeInterval = function() {
    return (Math.floor(Math.random() * 12) + 7) * 1000;
};